import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Fullstack.css'
import fullstackHero from "../../../assets/images/fullstackdeveloper.png";
import fullstackFlow from "../../../assets/images/fullstackdeveloper.png";

const FullstackDevelopment = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Full-Stack Development – BuddyTech Solutions </title>
        <meta name="description" content="End-to-end full‑stack solutions crafting database-to-UI experiences with seamless integration." />
        <meta name="keywords" content="full-stack development, web application" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Full-Stack Development – BuddyTech Solutions" />
        <meta property="og:description" content="End-to-end full‑stack solutions crafting database-to-UI experiences with seamless integration." />
        <meta property="og:keywords" content="full-stack development, web application" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development/fullstack" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Full-Stack Development – BuddyTech Solutions" />
        <meta name="twitter:description" content="End-to-end full‑stack solutions crafting database-to-UI experiences with seamless integration." />
        <meta name="twitter:keywords" content="full-stack development, web application" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="fullstack-container">
        <header className="fullstack-hero">
          <div className="fullstack-hero-content">
            <h1>Full Stack Development</h1>
            <p>
              We develop comprehensive solutions by integrating both front-end interfaces and back-end architectures, delivering fully functional and scalable web applications.
            </p>
          </div>
          <img src={fullstackHero} alt="Full Stack Development" className="fullstack-hero-img" />
        </header>

        <section className="fullstack-section">
          <div className="fullstack-text">
            <h2>End-to-End Expertise</h2>
            <p>
              Our full stack developers have a deep understanding of how user interfaces connect to server-side logic, ensuring optimal performance, maintainability, and user experience across the entire application.
            </p>
            <ul>
              <li>Frontend + Backend Integration</li>
              <li>RESTful APIs & GraphQL</li>
              <li>Authentication & Security</li>
              <li>Cloud Deployment & CI/CD</li>
              <li>Agile Development Workflow</li>
            </ul>
          </div>
          <img src={fullstackFlow} alt="Full Stack Flow" className="fullstack-img" />
        </section>

        <section className="fullstack-tools">
          <h2>Technologies We Use</h2>
          <div className="tools-grid">
            <span>React</span>
            <span>Angular</span>
            <span>Vue</span>
            <span>Next.js</span>
            <span>Node.js</span>
            <span>Express.js</span>
            <span>NestJS</span>
            <span>MongoDB</span>
            <span>PostgreSQL</span>
            <span>AWS / Docker</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default FullstackDevelopment;